<script>
    export let label = null
    export let value = ''
    export let edit = false
    export let alt = ''
    import { getContext } from 'svelte'
    import { InputText, Typography } from '.'
    import Edit from '../Icons/custom/Edit.svelte'
    const types = {
        text: InputText,
    }
    const count = getContext('count')
    const { index } = getContext('SetIndex')
    const myid = index()
    $count = myid
</script>

<span
    class="item"
    title={alt || label}
    style={$count === myid ? 'border-right: 0px' : ''}
>
    <div  style="display: flex; flex-direction: column; gap: var(--gap)">
        {#if label}
            <Typography
                type="subtitle"
                style="width: 100%; margin: 0;padding: 0; font-size: var(--label-font-size)"
                color="grey-800">{label}</Typography
            >
        {/if}
        <Typography style="margin: 0; font-size: var(--value-font-size)" type="body">
            {#if $$slots.default}
                <slot />
            {:else}
                {value || '...'}
            {/if}
        </Typography>
    </div>
    {#if edit}
        <Edit style="cursor: pointer" />
    {/if}
</span>

<style>
    :root {
        --min-height: 72px;
        --height: auto;
        --label-font-size: 14px;
        --value-font-size: 17px;
        --padding: 0 24px;
        --gap: 4px;
    }
    span {
        min-height: var(--min-height);
        height: var(--height);
        position: relative;
        width: 100%;
        font-family: Roboto;
        display: flex;
    }
    span.item {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: var(--padding);
        border-right: 1px var(--color-grey-300) solid;
    }
</style>
